import qs from 'qs'

import endpoint from 'config/endpoint'
import { getRequestHeaders } from 'routes/Menu/apis/_utils'
import { fetchRaw } from 'utils/fetch'

const options = {
  method: 'GET',
  cache: 'default',
  headers: {},
  timeout: null,
  includeCookies: false,
  useMenuService: true,
}

const constructURL = (endpointVersion, queryParams) => {
  const { date, 'preview[auth_user_id]': preview } = queryParams
  const queryString = `?${qs.stringify(queryParams, { arrayFormat: 'comma', encode: false })}`

  if (preview || endpointVersion === 1) {
    return `${endpoint('menu', endpointVersion)}/menus${queryString}`
  }

  return `${endpoint('menu', endpointVersion)}/menus${date ? '' : '/current'}${queryString}`
}

export function fetchMenus(accessToken, query, { date, endpointVersion = 1 } = {}) {
  const fetchOptions = {
    ...options,
    accessToken,
    headers: {
      ...options.headers,
      ...getRequestHeaders(),
    },
  }

  let adminLinkData
  const isAdminQuery = query && query['preview[auth_user_id]']
  if (isAdminQuery) {
    adminLinkData = {
      'preview[menu_id]': query['preview[menu_id]'],
      'preview[auth_user_id]': query['preview[auth_user_id]'],
      'preview[expiry]': query['preview[expiry]'],
      'preview[signature]': query['preview[signature]'],
    }
  }

  const requestQueryParams = {
    include: ['ingredients', 'value-collection'],
    addAlternatives: true,
    ...adminLinkData,
  }

  if (endpointVersion === 2 && date) {
    requestQueryParams.date = date
  }

  const url = constructURL(endpointVersion, requestQueryParams)

  return fetchRaw(url, {}, fetchOptions)
}

export function fetchMenusWithUserId(
  accessToken,
  query,
  userId,
  { date, endpointVersion = 1 } = {},
) {
  const fetchOptions = {
    ...options,
    accessToken,
    headers: {
      ...options.headers,
      ...getRequestHeaders(userId),
    },
  }

  const requestQueryParams = {
    include: ['ingredients', 'value-collection'],
    addAlternatives: true,
    userId,
  }

  if (endpointVersion === 2 && date) {
    requestQueryParams.date = date
  }

  const url = constructURL(endpointVersion, requestQueryParams)

  return fetchRaw(url, {}, fetchOptions)
}

export function fetchSimpleMenu(accessToken, userId) {
  const fetchOptions = {
    ...options,
    accessToken,
    headers: {
      ...options.headers,
      ...getRequestHeaders(userId),
    },
  }

  const requestQueryParams = {
    includeMenuRelationships: false,
    userId,
  }

  return fetchRaw(`${endpoint('menu')}/menus`, requestQueryParams, fetchOptions)
}
